import React from 'react';
import { createRoot } from 'react-dom/client';

import AppRoutes from './route';
import '../../static/stylesheets/style';

const root = createRoot(document.getElementById('app-container'));
root.render(<AppRoutes />);
